export default __webpack_public_path__ + "media/examples/video-c26c0ef4.jpg";